import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FilterOptionService } from './services/filter-option.service';
import { DivDataView, DivisionsAndDataViews, FilterOption } from 'src/app/global/filter-options-types';
import { FiltersService } from 'src/app/core/services/filters.service';
import { Role } from 'src/app/global/policy-types';
import { AuthorizationService } from 'src/app/core/services/authorization.service';
import { MixpanelService } from "../../core/services/mixpanel.service";
import { FEATURE_FLAGS, FeatureFlags } from 'src/app/config/AppInitializer.factory';
import { PolicyService } from 'src/app/core/services/policy.service';
import { GenericFilterComponent } from '../generic-filter-panel/generic-filter-panel.component';
@Component({
    selector: 'app-filter-selection',
    templateUrl: './filter-selection.component.html',
    styleUrls: ['./filter-selection.component.scss'],
    standalone: false
})
export class FilterSelectionComponent implements OnInit {
  @ViewChild('filterPanel')
  filterPanel!: GenericFilterComponent;
  error = false;
  filterOptions: FilterOption[] | undefined;

  divDataViews: { [division: string]: string[] } = DivisionsAndDataViews();

  divisions = Object.keys(this.divDataViews);

  selectedDivision = "";
  selectedDataView = "";

  userDisplayName = "";

  disableApplyButton = true;
  isFirstLoadComplete = false;

  constructor(
    private filterOptionService: FilterOptionService,
    private filterService: FiltersService,
    @Inject(FEATURE_FLAGS) private _featureFlags: FeatureFlags,
    private _authorizationService: AuthorizationService,
    private _policyService: PolicyService,
    private mixPanelService: MixpanelService
  ) {}

  ngOnInit() {
    // Checks if its first load, if filter buttons clicked from another
    // page after first load, it should not reset the selected values
    this.filterService.firstFilterLoadCompleteObservable.subscribe(
      (isComplete: boolean) => {
        this.isFirstLoadComplete = isComplete;
      }
    );

    const policy = this._policyService.currentPolicy;
    if (policy) {
      this.userDisplayName = policy.firstName || policy.lastName || '';
    }

    this.mixPanelService.track('EBR Dashboard Opened', {});

    // The division and dataview need to be updated if user navigates back to
    // filter selection from other pages after first load to preserve applied filters.
    this.filterOptionService.selectedDivisionDataView.subscribe(
      (dataView: DivDataView) => {
        if(this.filterService.getFirstLoadComplete() == true) {
          this.selectedDataView = dataView.dataView;
          this.selectedDivision = dataView.division;
        }
      }
    );

    this.filterOptionService.filterViewOptions.subscribe(
      (filterOptions) => this.filterOptions = filterOptions
    );

    this.setFilterOptionsAsPerSelection();
    this.filterService.setFirstLoadComplete(true);
  }

  private setFilterOptionsAsPerSelection() {
    if(this.filterOptions == undefined) {
      this.filterOptionService.setFilterViewOptions(this.filterOptionService.setFilterOptions());
    }
  }

  // Deprecate method on UI migration as new filter selection UI does not use mat-select
  onDivDataViewChange() {
    if (this.divDataViews[this.selectedDivision].length > 0 && this.selectedDataView == "") {
      this.selectedDataView = this.divDataViews[this.selectedDivision][0];
    }
    this.filterOptionService.setSelectedDivisionDataView({
      division: this.selectedDivision,
      dataView: this.divDataViews[this.selectedDivision].length > 0 ? this.selectedDataView : "",
    });

    this.filterOptionService.setFilterViewOptions(this.filterOptionService.setFilterOptions());

    //If the user modifies the data view setting, the account number will be set to empty.
    this.filterService.setSelectedAccountNos([]);
  }

  // TODO : This method is used for the refreshed UI as it does not use mat-select. Remove the old method after UI refresh is complete.
  onDivDataViewChangeButton(selectedDivision: string |undefined, selectedDataView: string | undefined) {
    if (selectedDivision) {
      this.selectedDivision = selectedDivision;
    }
    if (selectedDataView) {
      this.selectedDataView = selectedDataView;
    }
    if (this.divDataViews[this.selectedDivision].length > 0 && this.selectedDataView == "") {
      this.selectedDataView = this.divDataViews[this.selectedDivision][0];
    }
    this.filterOptionService.setSelectedDivisionDataView({
      division: this.selectedDivision,
      dataView: this.divDataViews[this.selectedDivision].length > 0 ? this.selectedDataView : "",
    });

    this.filterOptionService.setFilterViewOptions(this.filterOptionService.setFilterOptions());

    //If the user modifies the data view setting, the account number will be set to empty.
    this.filterService.setSelectedAccountNos([]);

    // reset other filters when division or data view changes
    this.filterService.resetFilterValues();
  }

  get Role() {
    return Role;
  }

  hasRole(role: Role) {
    return this._authorizationService.hasRole(role);
  }

  applyFilters() {
    this.filterPanel.clickApplyButton();
  }

  onHideProceedWithSelectionButtonChange(value: boolean) {
    this.disableApplyButton = value;
  }

}
